var defaultVariantMapping = {
    display1: 'p',
    display2: 'p',
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subheading1: 'span',
    subheading2: 'span',
    subheading3: 'span',
    subheading4: 'span',
    body1: 'p',
    body2: 'p',
    body3: 'p',
    body4: 'p',
    caption1: 'caption',
    caption2: 'caption',
    caption3: 'caption',
    caption4: 'caption',
    caption5: 'caption',
    overline1: 'span',
    overline2: 'span',
    button1: 'span',
    button2: 'span',
    button3: 'span',
    buttonLink1: 'span',
    buttonLink2: 'span',
    buttonLink3: 'span',
};

export { defaultVariantMapping };
